export { default } from './SocialLinks';



// WEBPACK FOOTER //
// ./src/components/Footer/components/SocialLinks/index.ts